import { render, staticRenderFns } from "./ClassesTableWidget.vue?vue&type=template&id=8f6b5052&scoped=true"
import script from "./ClassesTableWidget.vue?vue&type=script&lang=js"
export * from "./ClassesTableWidget.vue?vue&type=script&lang=js"
import style0 from "./ClassesTableWidget.vue?vue&type=style&index=0&id=8f6b5052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6b5052",
  null
  
)

export default component.exports